module.exports = __webpack_public_path__ + "img/cabin-on-fire.640b4be3.jpg";